import React, { useState } from 'react';
import '../css/dashboard.css';
import LimiteCard from './cardLimiteDeCredito';
import BoletoCard from './cardBoletos';
import DanfeCard from './cardDanfe';
import { IoWarningOutline } from "react-icons/io5";
import { temModulo } from "../../utils/acesso";

function Dashboard({ cliente, modulosAtivos }) {
    const [temBoletoVencido, setTemBoletoVencido] = useState(false);
    const podeFinanceiro = temModulo(modulosAtivos, "Financeiro");
    return (
        <div className="dashboard">
            <div className="dashboard-content">
                <div className='dashboard-painel'>
                    <h3 className='titulo'>Inicio</h3>
                    <p className='texto'>Um resumo de informações importantes para você.</p>

                    {temBoletoVencido && (
                        <div className="alert">
                            <p className="alertP"><IoWarningOutline size={22} /> Atenção: Constatamos a existência de boletos vencidos em sua conta. Regularize esses títulos para evitar qualquer interrupção no uso da plataforma.</p>
                        </div>
                    )}

                    <div className="cards">
                        {podeFinanceiro && (
                            <>
                                <LimiteCard cliente={cliente} />
                                <span></span>
                                <BoletoCard cliente={cliente} onBoletoVencido={setTemBoletoVencido} />
                                <span></span>
                                <DanfeCard cliente={cliente} />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
